import type { AnyAction, ThunkAction } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import { getReduxDevToolsOptions } from 'common/helpers'
import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'

import { signalRMiddleware } from './middleware'
import { rootReducer } from './reducers'

// @ts-expect-error TODO исправить ошибку ts
let store: AppStore = undefined
export const setupStore = () => {
  const configuredStore = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware().concat(signalRMiddleware)
    },
    devTools: getReduxDevToolsOptions('Core'),
  })
  store = configuredStore
  return configuredStore
}

export const getStore = () => store

export type RootState = ReturnType<typeof rootReducer>
type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = typeof store.dispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>
